export default __webpack_public_path__ + "e3aaef6ab13ca1b605dfab2f49f18446.png";